var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('headful',{attrs:{"title":"Caseen - Log Out"}}),_c('h2',[_vm._v("Logging out:")]),_c('br'),_c('br'),_c('md-progress-spinner',{attrs:{"md-diameter":60,"md-stroke":10,"md-mode":"indeterminate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }